<template>
    <div ref="resultBox" class="result">
        <img class="placard" :src="placard">
        <div ref="btnbox" class="btnbox">
            <div class="item" @click="saveClick"></div>
            <div class="item" @click="moreClick"></div>
        </div>
        <PlacardPop :url="placard" :show="popShow" @on-show-change="popShowChange"></PlacardPop>
        <SceneCodePop :resultData="resultData" :show="codeShow" @on-show-change="codeShowChange"></SceneCodePop>
        
    </div>
</template>

<script>
import PlacardPop from "@/components/PlacardPop.vue"
import SceneCodePop from "@/components/SceneCodePop.vue"
import utils from '@/js/utils'

export default {
    components: {
      PlacardPop,
      SceneCodePop,
    },
    data() {
        return {
            placard: null,
            popShow: false,
            moreurl: null,
            codeurl: null,
            codeShow: false,
            resultData: null,
        }
    },
    created() {
        
    },
    mounted() {
        this.resultData = window.resultData;
        if (!this.resultData) {
            this.$router.replace({
                name: 'index'
            })
            return;
        }

        this.$refs.resultBox.style.height = window.innerHeight + 'px';
        console.log('resultPage', this.resultData)
        let placard = this.userResult.placard;
        this.placard = placard;

        let pagemeta = this.pagemeta.resultPage;
        let bgcolor = pagemeta.bgcolor;
        let result = JSON.parse(this.userResult.result);
        if (result.bgcolor) {
            bgcolor = result.bgcolor;
        }
        if (bgcolor) {
            this.$refs.resultBox.style.backgroundColor = bgcolor;
        }
        this.moreurl = pagemeta.strval2;

        let btnurl = pagemeta.strval1;
        let btntop = pagemeta.intval1;
        if (this.isX && pagemeta.intval2) {
            btntop = pagemeta.intval2;
        }
        if (btnurl) {
            let img = new Image();
            img.src = btnurl;
            img.onload = () => {
                this.$refs.btnbox.style.backgroundImage = `url('${btnurl}')`;
                this.$refs.btnbox.style.backgroundSize = `100% ${utils.rem2px(img.height)}px`;
                this.$refs.btnbox.style.height = `${utils.rem2px(img.height)}px`;
                this.$refs.btnbox.style.bottom = `${utils.rem2px(btntop)}px`;
            }
        }
    },
    methods: {
        saveClick() {
            this.postEvent('saveClick');
            this.popShow = true;
        },
        moreClick() {
            this.postEvent('moreClick');
            // location.href = this.moreurl;
            // this.codeShow = true;
            if (this.moreurl) {
                location.href = this.moreurl;
            } else {
                this.codeShow = true;
            }
        },
        popShowChange(val) {
            this.popShow = val;
        },
        codeShowChange(val) {
            this.codeShow = val;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.placard {
    width: px2rem(750);
}
.placardop {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 100;
}
.sceneCode {
    z-index: 300;
}
.btnbox {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    display: flex;
    .item {
        width: 49%;
        height: 100%;
    }
}
</style>